<template>
    <div>
        <tr-text class="label" v-bind="props.label" :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)" v-if="showLabel" />
        <b-checkbox></b-checkbox>
        <i18n-text class="label" v-bind="props.label" :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)"
                v-if="props.info"
                />
    </div>
</template>

<script>
import TrText from "@/components/translation/TrText"

export default {
    name:     "I18nCheckbox",
    components: {TrText},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style>
    .label {
        width:   30%;
        display: inline-block;
    }
</style>